export default __webpack_public_path__ + "static/media/agent_ia.dd365b06.svg";